import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  card: css`
    height: auto;
    padding: 16px;
    border: 1px solid ${colors.prussian300};
    border-radius: 5px;
    background: ${colors.platinum};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    & + div {
      margin-top: 16px;
    }
  `,
  title: css`
    font-weight: bold;
    color: ${colors.prussian};
    font-size: 13px;
    font-family: 'Proxima Nova';
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  `,
  favoriteIconContainer: css`
    grid-column: 2;
    display: flex;
    justify-content: flex-end;
  `,
  grades: css`
    grid-column: 1;
  `,
  grade: css`
    width: 40px;
    padding: 0 4px;
    border: 1px solid ${colors.stone};
    background: ${colors.white};
    font-size: 14px;
    color: ${colors.slate};
    border-radius: 15px;
    & + span {
      margin-left: 4px;
    }
  `,
  textGray: css`
    font-size: 14px;
    color: ${colors.slate};
  `,
  cardBody: css`
    height: 68px;
  `,
  footer: css`
    display: grid;
    margin-top: 16px;
    grid-template-columns: [col1] 90% [col2] 10%;
  `,
  flyerImage: css`
    border-radius: 2.4px;
    margin-right: 8px;
  `,
  cardInformartions: css`
    width: 100%;
  `,
  deadlineBorder: css`
    border-color: #9f1853;
  `,
};

export default styles;
